import { LazyLoadingSectionLogger, LoggingSection } from "Logging/index";
import { InvalidArgumentException } from "./Exceptions";

export type GlobalContextIdentifier<T> = string | symbol | { new(): T;[Symbol.hasInstance]: (i: any) => boolean };

export enum ContextType {
    current,
    top,
}

const logger = LazyLoadingSectionLogger.create(LoggingSection.globalContext);

export class GlobalContext {
    public static register<T>(typeIdentifier: GlobalContextIdentifier<T>, property: any, contextType: ContextType = ContextType.current): void {
        const name = this._getIdentifierName(typeIdentifier);
        GlobalContext._register(name, property, contextType);
    }

    public static registerType<T>(type: { new(...args: any[]): T }, contextType: ContextType = ContextType.current): void {
        GlobalContext._register(type.name, type, contextType);
    }

    private static _register(name: string, property: any, contextType: ContextType = ContextType.current): void {
        const context = contextType === ContextType.top && (self as any).top ? (self as any).top : self as any;
        if (!context.TescoSW)
            context.TescoSW = {};
        if (!context.TescoSW[name])
            context.TescoSW[name] = property;
    }

    public static get<T>(typeIdentifier: GlobalContextIdentifier<T>, contextType: ContextType = ContextType.current): T {
        const name = this._getIdentifierName(typeIdentifier);
        return GlobalContext._get<T>(name, contextType);
    }

    public static getType<T>(type: { new(...args: any[]): any }, contextType: ContextType = ContextType.current): T {
        const name = this._getIdentifierName(type.name);
        return GlobalContext._get<T>(name, contextType);
    }

    private static _get<T>(name: string, contextType: ContextType = ContextType.current): T {
        const context = contextType === ContextType.top && (self as any).top ? (self as any).top : self as any;
        const res = context.TescoSW && context.TescoSW[name] as T;
        if (!res)
            logger.error(`Global object ${name} not found in ${ContextType[contextType]} context!`);
        return res;
    }

    private static _getIdentifierName(typeIdentifier: GlobalContextIdentifier<any>): string {
        switch (typeof typeIdentifier) {
            case "function":
                return (typeIdentifier as any).name;
            case "string":
                return typeIdentifier;
            case "symbol":
                return /Symbol\((\w*)\)/.exec((typeIdentifier as any).toString()) ![1];
        }
        throw new InvalidArgumentException("typeIdentifier");
    }
}
